'use strict';
function initializeEvents() {
    $(window).scroll(function () {
        const targets = document.querySelectorAll(".scroll-parrallax-effect");
        const lazyLoad = (target) => {
            const io = new IntersectionObserver((entries, observer) => {
                entries.forEach( entry => {
                    let content = entry.target.parentNode;
                    if (entry.isIntersecting && entry.boundingClientRect.top < 40) {
                        if (!$(content).hasClass('animate-active')) {
                            content.classList.add("animate-active");
                            let textElement = $(content).find('.module3-4-text-cta'),
                                textElementTheme = textElement.attr('data-bg-theme'),
                                bgC = '240, 239, 235',
                                textColor = '#000000',
                                TextOP = 0.5;
                            if (textElementTheme === 'dark') {
                                bgC = '0, 0, 0';
                                textColor = '#FFFFFF';
                                TextOP = 0.3;
                            }
                            textElement.css('color', textColor);
                            textElement.animate({ backgroundColor: `rgba(${bgC}, ${TextOP})`, opacity: 0.7 }, 500)
                                .animate({ backgroundColor: `rgba(${bgC}, ${TextOP + 0.2})`, opacity: 1 }, 500)
                                .animate({ backgroundColor: `rgba(${bgC}, ${TextOP + 0.4})` }, 500);
                        }
                    } else {
                        content.classList.remove("animate-active");
                        $(content).find('.module3-4-text-cta').removeAttr('style');
                    }
                    observer.disconnect();
                })
            }, { threshold: [0.2] });
            io.observe(target);
        }
        targets.forEach(lazyLoad);
    });
}
const init = function () {
	initializeEvents();
};
export default { init };